import React, { forwardRef } from "react"
import NumberFormat from "react-number-format"

/**
 * PercentInput component for formatting percentage values
 * Uses react-number-format to handle percentage formatting with comma as decimal separator
 */
export const PercentInput = forwardRef((props, ref) => {
  const { onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        })
      }}
      allowEmptyFormatting
      allowedDecimalSeparators={[".", ","]}
      fixedDecimalScale
      decimalScale={2}
      decimalSeparator=","
      thousandSeparator="."
      isNumericString
      suffix="%"
    />
  )
})
